import * as PDFJS from 'pdfjs-dist'
import pdfjsWorkerEntry from 'pdfjs-dist/build/pdf.worker.entry'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.js'

// const worker = new Worker('pdf.worker.min.js');
PDFJS.GlobalWorkerOptions.workerSrc = 'pdfjs-dist/build/pdf.worker.min.js';
// PDFJS.GlobalWorkerOptions.workerPort = worker;

var pdfDoc = null,
    pageNum = 1,
    pageRendering = false,
    pageNumPending = null,
    scale = 2
    // canvas = document.getElementById('the-canvas'),

/**
 * Get page info from document, resize canvas accordingly, and render page.
 * @param num Page number.
 */
function renderPage(num,canvas) {
  pageRendering = true;
  var ctx = canvas.getContext('2d');
  // Using promise to fetch the page
  pdfDoc.getPage(num).then(function(page) {
    var viewport = page.getViewport({scale: scale});
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    // Render PDF page into canvas context
    var renderContext = {
      canvasContext: ctx,
      viewport: viewport
    };
    var renderTask = page.render(renderContext);

    // Wait for rendering to finish
    renderTask.promise.then(function() {
      pageRendering = false;
      if (pageNumPending !== null) {
        // New page rendering is pending
        renderPage(pageNumPending);
        pageNumPending = null;
      }
    });
  });

  // Update page counters
//   document.getElementById('page_num').textContent = num;
}

/**
 * If another page rendering in progress, waits until the rendering is
 * finised. Otherwise, executes rendering immediately.
 */
function queueRenderPage(num) {
  if (pageRendering) {
    pageNumPending = num;
  } else {
    renderPage(num);
  }
}

/**
 * Displays previous page.
 */
function onPrevPage() {
  if (pageNum <= 1) {
    return;
  }
  pageNum--;
  queueRenderPage(pageNum);
}
// document.getElementById('prev').addEventListener('click', onPrevPage);

/**
 * Displays next page.
 */
function onNextPage() {
  if (pageNum >= pdfDoc.numPages) {
    return;
  }
  pageNum++;
  queueRenderPage(pageNum);
}
// document.getElementById('next').addEventListener('click', onNextPage);

/**
 * Asynchronously downloads PDF.
 */


let viewerPDFlength = (document.querySelectorAll('.viewer-pdf-content').length) - 1


// console.log(viewerPDFlength);
for (let viwerIndex = 0; viwerIndex <= viewerPDFlength; viwerIndex++) {
    let urlPDF = document.getElementsByClassName('viewer-pdf-content')[viwerIndex].getAttribute('data-pdf');
    // console.log(url);
    PDFJS.getDocument({url: urlPDF, verbosity: PDFJS.VerbosityLevel.ERRORS}).promise.then(function(pdfDoc_) {
        pdfDoc = pdfDoc_;
        let timeRendering = pdfDoc.numPages <= 5 ?0:3000;
        // document.getElementById('page_count').textContent = pdfDoc.numPages;
        // renderPage(1,document.getElementsByClassName('viewer-pdf')[viwerIndex]);
        for (let index = 1; index <= pdfDoc.numPages; index++) {
            let renderTime = setTimeout(()=> {
                const element = document.createElement('canvas');
                document.getElementsByClassName('viewer-pdf')[viwerIndex].append(element)
                renderPage(index,element);
            },timeRendering * index)
            
        }
        // Initial/first page rendering
        //   renderPage(pageNum);
    });
}